import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store"; // Correct path to RootState
import { CalendarFold, ChevronRight } from "lucide-react";
import { convertDecimalHoursToHM } from "../../../utils/employeeTimeCardhelper";

interface TimeCardDayDetailEntry {
  id: string;
  start_datetime: string;
  end_datetime: string;
  regular_hours: string;
  hours: string;
  earning_code: {
    name: string;
  };
  department: {
    name: string;
  };
}

const TimeCardDayDetailPage: React.FC = () => {
  const navigate = useNavigate(); 
  const { date } = useParams<{ date: string }>(); 
  const { groupedTimesheets } = useSelector(
    (state: RootState) => state.employeeTimeCardData
  );
  const [timeCardDayDetailData, setTimeCardDayDetailData] = useState<
    TimeCardDayDetailEntry[]
  >([]);

  const formatTimeCardDate = (dateString: string): string => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      //   year: "numeric",
      month: "short",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const formatTimeCardTime = (dateTimeString: string): string => {
    const date = new Date(dateTimeString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  useEffect(() => {
    if (groupedTimesheets && date) {
      // Filter timesheet entries for the selected date
      const filteredData: any =
        groupedTimesheets?.data?.timesheet_entries_by_date?.[date] ?? [];
      setTimeCardDayDetailData(filteredData);
    }
  }, [date, groupedTimesheets]);

  if (timeCardDayDetailData.length === 0)
    return <div>No timecard data available for this day.</div>;

  return (
    <div className="overflow-y-scroll flex-1 px-4 pb-16 scrollbar-none">
      <div className="flex text-xl mb-4 text-blue-500 font-bold">
        {" "}
        <CalendarFold className="text-blue-500" /> {` `}
        <span className="mx-2" />
        {date
          ? formatTimeCardDate(date)
          : "Invalid date,Format the selected date"}
      </div>

      <div className="bg-gray-100 p-4 rounded-lg mb-4">
        <div className="text-xl font-semibold text-center">
          {" "}
          {groupedTimesheets?.data?.pay_period_totals?.total_hours || 0.0}
          <span className="text-md"> hours worked</span>
        </div>
        <div className="text-center text-xs text-gray-600 mt-1">
          Clocked Out: Yesterday at 11:32 PM
        </div>
        {/* <div className="mt-4 flex justify-around items-center">
          <button
            className="bg-blue-500 text-white py-1 px-6 rounded-full text-sm font-medium"
            onClick={() => alert("Clock In clicked")}
          >
            🕒 Clock In
          </button>
          <button className="border border-blue-600 text-blue-500 py-1 px-4 rounded-full text-sm font-medium">
            Add Entry
          </button>
        </div> */}
      </div>

      {timeCardDayDetailData.map((entry, index) => (
        <div key={index} className="border-t flex items-start mb-4 py-1">
          {/* <div className="w-1/4 font-semibold text-xs">
            {formatTimeCardTime(entry?.start_datetime)} – {formatTimeCardTime(entry?.end_datetime)}({entry?.earning_code?.name})
          </div> */}
          <div className="w-full">
            <div className="flex flex-row justify-between items-center">
              {/* <div className="text-xs text-gray-500">
                {entry?.earning_code?.name}
              </div> */}
              <div className=" flex flex-col ">
                <div className="flex items-center space-x-1">
                  <span>{convertDecimalHoursToHM(Number(entry?.hours))}</span>
                </div>

                <div className="w-full font-semibold text-xs">
                  {formatTimeCardTime(entry?.start_datetime)} –{" "}
                  {formatTimeCardTime(entry?.end_datetime)}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Change History */}
      <div className="mt-6 flex">
        <div className="font-semibold text-md mb-2">
          Change History ({timeCardDayDetailData?.length || 0} Events)
        </div>
        <div
          className="cursor-pointer text-xs flex items-center justify-center text-gray-500"
          onClick={() => navigate(`/m-changeHistory/${date}`)} // Routing to the specific date details page
        >
          <ChevronRight />
        </div>
        {/* Change history data would go here */}
      </div>
    </div>
  );
};

export default TimeCardDayDetailPage;
